import React from "react";
import { PreviewModal as CorePreviewModal } from "@jelly/ui";

import styles from "./PreviewModal.module.scss";

export const PreviewModal: React.FC<React.ComponentProps<typeof CorePreviewModal>> = (props) => {
  return <CorePreviewModal {...props} classNames={styles} />;
};

//TODO: override X button style
// TODO: add ability to close modal on escape keyboard button press
